import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Building, Users, Search, CheckCircle } from "lucide-react";
import { GradientHeading } from "@/components/ui/gradient-heading";
import { SEOPageMeta } from "@/components/SEOPageMeta";
import { SEOBreadcrumbSchema } from "@/components/SEOBreadcrumbSchema";
import { useNavigate } from "react-router-dom";
const Unternehmen = () => {
  const navigate = useNavigate();
  const handleContactClick = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.querySelector('#contact');
      contactSection?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 100);
  };
  const recruitingSteps = [{
    number: "1",
    title: "Vakanzen ermitteln",
    description: "Gemeinsame Analyse Ihrer offenen Positionen und Anforderungen"
  }, {
    number: "2",
    title: "Bewerbende ausfindig machen",
    description: "Aktive Suche über unseren Pool an Bewerbenden und diverse Kanäle"
  }, {
    number: "3",
    title: "Pre-Screening & Referenzen",
    description: "Umfassende Prüfung und Bewertung der Bewerbenden"
  }, {
    number: "4",
    title: "Vorstellung der Bewerbenden",
    description: "Präsentation der besten Bewerbenden mit unserer Einschätzung"
  }, {
    number: "5",
    title: "Begleitung Bewerbungsgespräch",
    description: "Optionale Begleitung des Auswahlprozesses"
  }];
  return <div className="min-h-screen bg-background">
      <SEOPageMeta 
        title="Headhunter & Personalvermittler für Unternehmen"
        description="Führungskräfte für Hotellerie & Gastronomie finden. Bewährter Recruitingprozess mit Active Sourcing und umfassendem Screening. Seit 2002 über 900 erfolgreiche Vermittlungen."
        path="/unternehmen"
        keywords={["Headhunter Hotellerie", "Personalvermittlung Gastronomie", "Executive Search", "Führungskräfte finden", "Recruiting Hotellerie"]}
      />
      <SEOBreadcrumbSchema items={[
        { name: "Home", path: "/" },
        { name: "Für Unternehmen", path: "/unternehmen" }
      ]} />
      <Header />
      
      {/* Enhanced Hero Section - Mobile Optimized */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Enhanced Background with Depth */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-elegant opacity-90" />
          
          {/* Layered Background Elements - Mobile Responsive */}
          <div className="absolute top-1/4 right-1/4 w-48 h-48 sm:w-96 sm:h-96 rounded-full blur-3xl opacity-40" style={{
          background: 'radial-gradient(circle, hsl(210 65% 32% / 0.1) 0%, transparent 70%)'
        }} />
          <div className="absolute bottom-1/3 left-1/3 w-32 h-32 sm:w-64 sm:h-64 rounded-full blur-2xl opacity-30" style={{
          background: 'radial-gradient(circle, hsl(210 65% 32% / 0.08) 0%, transparent 70%)'
        }} />
          
          {/* Subtle Grid Pattern */}
          <div className="absolute inset-0 opacity-[0.015]" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, hsl(210 65% 32%) 1px, transparent 0)`,
          backgroundSize: '30px 30px'
        }} />
        </div>
        
        <div className="relative z-10 container mx-auto px-4 sm:px-8 text-center">
          <div className="max-w-4xl mx-auto animate-fade-in">
            <div className="mb-6 sm:mb-8">
              <div className="flex items-center justify-center space-x-3 sm:space-x-4 mb-4 sm:mb-6">
                <span className="w-12 sm:w-16 h-px bg-gradient-to-r from-transparent via-primary to-transparent"></span>
                <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
                backgroundColor: 'hsl(210 65% 32%)'
              }}></div>
                <span className="w-12 sm:w-16 h-px bg-gradient-to-r from-transparent via-primary to-transparent"></span>
              </div>
              <p className="font-medium tracking-wider uppercase text-xs sm:text-sm mb-4 sm:mb-6" style={{
              color: 'hsl(210 65% 32%)'
            }}>FÜR UNTERNEHMEN</p>
            </div>

            <h1 className="text-3xl sm:text-5xl md:text-7xl font-display font-extralight mb-6 sm:mb-8 leading-tight px-4 sm:px-0">
              <span className="bg-gradient-to-br from-foreground via-foreground to-primary bg-clip-text text-transparent">
                Führungskräfte
              </span>
              <span className="block text-2xl sm:text-4xl md:text-5xl font-light mt-2 sm:mt-4" style={{
              color: 'hsl(210 65% 32%)'
            }}>
                finden & gewinnen
              </span>
            </h1>
            
            <div className="max-w-3xl mx-auto mb-8 sm:mb-12 relative px-4 sm:px-0">
              <div className="hidden sm:block absolute -left-6 top-0 w-1 h-full bg-gradient-to-b from-transparent via-primary to-transparent opacity-30"></div>
              <p className="text-base sm:text-xl text-muted-foreground leading-relaxed font-light">
                Unsere bewährte Formel für erfolgreiche Personalvermittlung in der Hotellerie & Gastronomie. 
                Wir finden nicht nur Bewerbende – wir finden die richtigen Menschen für Ihre Unternehmenskultur.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center px-4 sm:px-0">
              <Button variant="default" size="lg" className="font-medium text-base sm:text-lg px-8 sm:px-10" onClick={handleContactClick}>
                Erstgespräch
              </Button>
              
            </div>
          </div>
        </div>

        {/* Enhanced Bottom Shape */}
        <div className="absolute bottom-0 left-0 right-0 h-24 sm:h-32 bg-background organic-shape">
          <div className="absolute inset-0 bg-gradient-accent-subtle opacity-50"></div>
        </div>
      </section>

      {/* Our Formula Section - Mobile Optimized */}
      <section className="py-12 sm:py-20 px-4 sm:px-8">
        <div className="container mx-auto max-w-6xl">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <GradientHeading size="xl">
                Unsere Formel für Unternehmen
              </GradientHeading>
              <div className="space-y-4 sm:space-y-6 text-muted-foreground">
                <p className="text-base sm:text-lg leading-relaxed">
                  Bei dem Aufspüren von Talenten für die Hotellerie & Gastronomie verlassen wir uns nicht nur auf diverse Jobbörsen und Onlineportale.
                </p>
                <p className="text-base sm:text-lg leading-relaxed">
                  Wir verfügen vielmehr über einen gewachsenen Pool an Bewerbenden, entwickeln individuelle On- und Offline Kampagnen und steuern das Recruiting aktiv über die gängigen Social Media Kanäle.
                </p>
                <div className="bg-primary/10 border-l-4 border-primary p-4 sm:p-6 rounded-r-lg">
                  <p className="text-base sm:text-lg font-medium text-foreground">
                    Kurz gesagt: Alle haben ihren Spot, an dem man sie findet.
                  </p>
                </div>
              </div>
            </div>
            <div className="relative order-1 lg:order-2">
              <div className="glass-effect bg-background/50 p-4 sm:p-8 rounded-2xl">
                <div className="grid grid-cols-2 gap-4 sm:gap-6">
                  <div className="text-center">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-primary/20 to-primary/10 rounded-xl flex items-center justify-center mx-auto mb-2 sm:mb-3">
                      <Search className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                    </div>
                    <h3 className="font-display font-light text-foreground mb-1 sm:mb-2 text-sm sm:text-base">Active Sourcing</h3>
                    <p className="text-xs sm:text-sm text-muted-foreground">Gezielte Suche nach Bewerbenden</p>
                  </div>
                  <div className="text-center">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-primary/20 to-primary/10 rounded-xl flex items-center justify-center mx-auto mb-2 sm:mb-3">
                      <Users className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                    </div>
                    <h3 className="font-display font-light text-foreground mb-1 sm:mb-2 text-sm sm:text-base">Pool an Bewerbenden</h3>
                    <p className="text-xs sm:text-sm text-muted-foreground">Gewachsenes Netzwerk</p>
                  </div>
                  <div className="text-center">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-primary/20 to-primary/10 rounded-xl flex items-center justify-center mx-auto mb-2 sm:mb-3">
                      <Building className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                    </div>
                    <h3 className="font-display font-light text-foreground mb-1 sm:mb-2 text-sm sm:text-base">Branchenexpertise</h3>
                    <p className="text-xs sm:text-sm text-muted-foreground">Hotellerie & Gastronomie</p>
                  </div>
                  <div className="text-center">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-primary/20 to-primary/10 rounded-xl flex items-center justify-center mx-auto mb-2 sm:mb-3">
                      <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                    </div>
                    <h3 className="font-display font-light text-foreground mb-1 sm:mb-2 text-sm sm:text-base">Qualitätsprüfung</h3>
                    <p className="text-xs sm:text-sm text-muted-foreground">Umfassendes Screening</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Challenge Section - Mobile Optimized */}
      <section className="py-12 sm:py-20 px-4 sm:px-8 bg-muted/30">
        <div className="container mx-auto max-w-4xl text-center">
          <GradientHeading size="xl" align="center" className="mb-6 sm:mb-8 px-4 sm:px-0">
            Die Gäste sind da, die Mitarbeiter nicht
          </GradientHeading>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto px-4 sm:px-0">
            Geeignete Bewerbende für vakante Positionen in der Hotellerie & Gastronomie zu finden ist zeitintensiv. 
            Es erfordert Erfahrung bezüglich der richtigen Kanäle oder Wege und ist nicht selten mit hohen Kosten verbunden. 
            Scholz Interim bietet Ihrem Unternehmen folgenden vollständigen Recruitingprozess:
          </p>
        </div>
      </section>

      {/* Recruiting Process - Optimized for 5 Steps */}
      <section className="py-12 sm:py-20 px-4 sm:px-8">
        <div className="container mx-auto max-w-7xl">
          <GradientHeading size="xl" align="center" className="mb-8 sm:mb-16 px-4 sm:px-0">
            Unser Recruitingprozess
          </GradientHeading>
          
          {/* Desktop: 5-column layout, Tablet: 2+3 layout, Mobile: single column */}
          <div className="hidden lg:grid lg:grid-cols-5 gap-6 xl:gap-8">
            {recruitingSteps.map((step, index) => <Card key={index} className="p-4 xl:p-6 glass-effect hover:shadow-elegant transition-all duration-300 animate-fade-in group" style={{
            animationDelay: `${index * 0.1}s`
          }}>
                <div className="text-center">
                  <div className="w-12 h-12 xl:w-14 xl:h-14 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground rounded-full flex items-center justify-center font-bold text-lg xl:text-xl mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                    {step.number}
                  </div>
                  <h3 className="text-base xl:text-lg font-display font-light text-foreground mb-3 leading-tight">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
                
                {/* Process Arrow */}
                {index < recruitingSteps.length - 1 && <div className="absolute -right-3 top-1/2 transform -translate-y-1/2 w-6 h-6 text-primary/40 hidden xl:block">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-6 h-6">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </div>}
              </Card>)}
          </div>

          {/* Tablet: 2+3 balanced layout */}
          <div className="hidden md:block lg:hidden">
            <div className="grid grid-cols-2 gap-6 mb-6">
              {recruitingSteps.slice(0, 2).map((step, index) => <Card key={index} className="p-5 glass-effect hover:shadow-elegant transition-all duration-300 animate-fade-in" style={{
              animationDelay: `${index * 0.1}s`
            }}>
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground rounded-full flex items-center justify-center font-bold text-lg">
                      {step.number}
                    </div>
                    <div>
                      <h3 className="text-lg font-display font-light text-foreground mb-2">
                        {step.title}
                      </h3>
                      <p className="text-muted-foreground text-sm leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </Card>)}
            </div>
            <div className="grid grid-cols-3 gap-4">
              {recruitingSteps.slice(2).map((step, index) => <Card key={index + 2} className="p-4 glass-effect hover:shadow-elegant transition-all duration-300 animate-fade-in" style={{
              animationDelay: `${(index + 2) * 0.1}s`
            }}>
                  <div className="text-center">
                    <div className="w-10 h-10 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground rounded-full flex items-center justify-center font-bold text-base mx-auto mb-3">
                      {step.number}
                    </div>
                    <h3 className="text-base font-display font-light text-foreground mb-2 leading-tight">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground text-xs leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </Card>)}
            </div>
          </div>

          {/* Mobile: Single column with enhanced design */}
          <div className="md:hidden space-y-4">
            {recruitingSteps.map((step, index) => <Card key={index} className="p-4 glass-effect hover:shadow-elegant transition-all duration-300 animate-fade-in relative" style={{
            animationDelay: `${index * 0.1}s`
          }}>
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground rounded-full flex items-center justify-center font-bold text-lg">
                    {step.number}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-display font-light text-foreground mb-2">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
                
                {/* Process connector for mobile */}
                {index < recruitingSteps.length - 1 && <div className="absolute left-8 -bottom-2 w-0.5 h-4 bg-gradient-to-b from-primary/40 to-transparent"></div>}
              </Card>)}
          </div>
        </div>
      </section>

      {/* Personal Approach */}
      <section className="py-20 px-8 bg-muted/30">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <GradientHeading size="xl" align="center" className="mb-6">
              Warum wir Sie persönlich kennenlernen möchten
            </GradientHeading>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-lg text-muted-foreground leading-relaxed">
                Um das für Sie optimale Hotel- und Restaurantfachpersonal zu finden, haben wir einen einfachen, 
                jedoch für uns sehr aufschlussreichen Ansatz: wir möchten Sie und Ihre Häuser persönlich kennenlernen.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-gradient-to-br from-primary to-primary/80 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <CheckCircle className="w-4 h-4 text-primary-foreground" />
                  </div>
                  <p className="text-muted-foreground">Verstehen Ihrer Unternehmenskultur und -werte</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-gradient-to-br from-primary to-primary/80 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <CheckCircle className="w-4 h-4 text-primary-foreground" />
                  </div>
                  <p className="text-muted-foreground">Analyse der spezifischen Anforderungen Ihrer Position</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-gradient-to-br from-primary to-primary/80 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <CheckCircle className="w-4 h-4 text-primary-foreground" />
                  </div>
                  <p className="text-muted-foreground">Perfekte Matching zwischen Kandidat und Unternehmen</p>
                </div>
              </div>
            </div>
            <Card className="p-8 glass-effect">
              <h3 className="text-xl font-display font-light text-foreground mb-4 text-center">
                Unser Versprechen
              </h3>
              <div className="space-y-4 text-center">
                <div className="bg-primary/10 p-4 rounded-lg">
                  <p className="text-sm text-muted-foreground font-medium">
                    Nur wer das Unternehmen kennt, kann die richtigen Kandidaten finden
                  </p>
                </div>
                <Button variant="luxury" className="w-full" onClick={handleContactClick}>
                  Erstgespräch vereinbaren
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* Service Navigation Section */}
      <section className="py-16 px-8 bg-muted">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <GradientHeading size="xl" align="center" className="mb-4">
              Entdecken Sie unsere Leistungsbereiche
            </GradientHeading>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Von der gezielten Personalsuche bis hin zur strategischen Unternehmensberatung – 
              wir bieten maßgeschneiderte Lösungen für Ihre Herausforderungen.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {/* Headhunting Card */}
            <a href="/kandidaten" className="block">
              <Card className="p-8 glass-effect hover:shadow-elegant transition-all duration-300 group cursor-pointer h-full">
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Search className="w-8 h-8 text-primary-foreground" />
                  </div>
                  <h3 className="text-xl font-display font-light text-foreground mb-4">
                    Headhunting
                  </h3>
                  <p className="text-muted-foreground mb-6 leading-relaxed">
                    Gezielte Suche und Ansprache von Führungskräften und Spezialisten 
                    für Ihre vakanten Positionen in der Hotellerie & Gastronomie.
                  </p>
                  <div className="inline-flex items-center text-primary font-medium group-hover:gap-3 gap-2 transition-all duration-300">
                    Mehr erfahren
                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Card>
            </a>

            {/* Verpachtung Card */}
            <a href="/verpachtung" className="block">
              <Card className="p-8 glass-effect hover:shadow-elegant transition-all duration-300 group cursor-pointer h-full">
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Building className="w-8 h-8 text-primary-foreground" />
                  </div>
                  <h3 className="text-xl font-display font-light text-foreground mb-4">
                    Verpachtung
                  </h3>
                  <p className="text-muted-foreground mb-6 leading-relaxed">
                    Professionelle Vermittlung und Beratung bei der Verpachtung 
                    von Gastronomiebetrieben und Hotelimmobilien.
                  </p>
                  <div className="inline-flex items-center text-primary font-medium group-hover:gap-3 gap-2 transition-all duration-300">
                    Mehr erfahren
                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Card>
            </a>

            {/* Managementleistungen Card */}
            <a href="/managementleistungen" className="block">
              <Card className="p-8 glass-effect hover:shadow-elegant transition-all duration-300 group cursor-pointer h-full">
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-primary to-primary/80 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Users className="w-8 h-8 text-primary-foreground" />
                  </div>
                  <h3 className="text-xl font-display font-light text-foreground mb-4">
                    Managementleistungen
                  </h3>
                  <p className="text-muted-foreground mb-6 leading-relaxed">
                    Umfassende Beratung und Interim Management für strategische 
                    Projekte und operative Herausforderungen.
                  </p>
                  <div className="inline-flex items-center text-primary font-medium group-hover:gap-3 gap-2 transition-all duration-300">
                    Mehr erfahren
                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Card>
            </a>
          </div>

          {/* Call to Action */}
          <div className="text-center mt-12 pt-8 border-t border-border/50">
            <p className="text-muted-foreground mb-6">
              Haben Sie Fragen zu unseren Leistungen oder möchten Sie ein Beratungsgespräch?
            </p>
            <Button variant="luxury" size="lg" onClick={handleContactClick}>
              Jetzt Kontakt aufnehmen
            </Button>
          </div>
        </div>
      </section>
      <Footer />
    </div>;
};
export default Unternehmen;